import {
  SET_SAVE_ORGANIZATION_INSTANCE_NEXT_LOGIN,
  ACT_SET_REFRESH_DEFAULT,
} from "@/store/modules/Organization/types";

export default [
  `Organization/${SET_SAVE_ORGANIZATION_INSTANCE_NEXT_LOGIN}`,
  `Organization/${ACT_SET_REFRESH_DEFAULT}`,
];
